import React, { MutableRefObject } from "react";
import VirtualGroupingModal from "~/common/AddToCartModal/VirtualGroupingModal";
import AccessoriesModal from "~/common/AddToCartModal/AccessoriesModal";
import OutletModal from "~/common/AddToCartModal/OutletModal";
import ProductWarningModal from "~/common/AddToCartModal/ProductWarningModal";
import CartLimitModal from "~/ProductDetails/Pricing/AddToCart/CartLimitModal";
import { AddToCartModalUserInputs } from "~/common/AddToCartModal";
import {
  Accessory,
  GroupingAttributes,
  OutletAttributes,
} from "~/common/Store/models/ProductListing";

export interface ProductModalData {
  itemNumber: string;
  activeModal:
    | ""
    | "accessories"
    | "virtualGrouping"
    | "warranty"
    | "commercialUse"
    | "warning"
    | "outlet";
  closeModal: () => void;
  submitModal: (result?: AddToCartModalUserInputs | undefined) => void;
  hasAcknowledgedProductWarning: MutableRefObject<boolean>;
  hasAcknowledgedOutletItem: MutableRefObject<boolean>;
  hasCustomizableProductsOverride: boolean;
  cartLimitMessage: string;
  isCartModalOpen: boolean;
  setIsCartModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  accessories: readonly Accessory[];
  hasAccessories: boolean;
  setAccessories: React.Dispatch<React.SetStateAction<readonly Accessory[]>>;
  groupingAttributes: GroupingAttributes;
  outletAttributes: OutletAttributes;
  isOutlet: boolean;
  warningContent: string | undefined;
  previouslyPurchased: boolean;
  displayRequiredCustomization: boolean;
  quantity: string;
  itemQuantityVisible: boolean;
  handleQuantityChange: (value: string) => void;
  selectedAccessoryIds: string[] | undefined;
}

const ProductModals = ({
  itemNumber,
  activeModal,
  isCartModalOpen,
  accessories,
  hasAccessories,
  setAccessories,
  groupingAttributes,
  outletAttributes,
  isOutlet,
  submitModal,
  closeModal,
  hasAcknowledgedOutletItem,
  hasAcknowledgedProductWarning,
  hasCustomizableProductsOverride,
  cartLimitMessage,
  setIsCartModalOpen,
  warningContent,
  previouslyPurchased,
  displayRequiredCustomization,
  quantity,
  itemQuantityVisible,
  selectedAccessoryIds,
  handleQuantityChange,
}: ProductModalData) => {
  const isVirtualGroupingModalOpen = activeModal === "virtualGrouping";
  const isAccessoriesModalOpen = activeModal === "accessories";
  const isOutletModalOpen = activeModal === "outlet";
  const isProductWarningModalOpen = activeModal === "warning";

  return (
    <>
      {isVirtualGroupingModalOpen && groupingAttributes && (
        <VirtualGroupingModal
          {...{
            itemQuantityVisible,
            hasAccessories,
            setAccessories,
            groupingAttributes,
            isOpen: isVirtualGroupingModalOpen,
            closeModal,
            submitModal,
            quantity,
            handleQuantityChange,
            isCustomizable:
              !isOutlet &&
              (hasCustomizableProductsOverride || displayRequiredCustomization),
            isProductListing: true,
            previouslyPurchased,
          }}
        />
      )}
      {isAccessoriesModalOpen && !selectedAccessoryIds && (
        <AccessoriesModal
          {...{
            accessories,
            isOpen: isAccessoriesModalOpen,
            itemNumber,
            closeModal,
            submitModal,
            previouslyPurchased,
          }}
        />
      )}
      {outletAttributes && isOutletModalOpen && (
        <OutletModal
          {...{
            outletAttributes,
            isOpen: isOutletModalOpen,
            hasAcknowledgedOutletItem,
            closeModal,
            submitModal,
          }}
        />
      )}
      {warningContent && isProductWarningModalOpen && (
        <ProductWarningModal
          {...{
            warningContent,
            isOpen: isProductWarningModalOpen,
            hasAcknowledgedProductWarning,
            closeModal,
            submitModal,
          }}
        />
      )}
      {isCartModalOpen && (
        <CartLimitModal
          modalOpen={isCartModalOpen}
          setModalOpen={setIsCartModalOpen}
          cartLimitMessage={cartLimitMessage}
        />
      )}
    </>
  );
};

export default ProductModals;
